function dm_c12() {

    const $btn = $('.c12-load-more');
    const $container = $('.c12-row');
    let page = 1;
    const maxPages = parseInt($container.data('max-pages') || 9999);

    $btn.on('click', function() {
        page++;
        $.ajax({
            url: dm_loadmore_people.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'dm_load_more_people',
                nonce: dm_loadmore_people.nonce,
                page: page
            },
            beforeSend: function() {
                $btn.text('Loading...');
            },
            success: function(res) {
                if (res.success) {
                    $container.append(res.data.html);
                    if (page >= res.data.max_pages) {
                        $btn.hide();
                    } else {
                        $btn.text('Load more +');
                    }
                } else {
                    $btn.hide();
                }
            },
            error: function() {
                $btn.text('Error');
            }
        });
    });

}

export { dm_c12 };
